import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"

import {getConfigValue} from "@elements/config-utils";
// @ts-ignore



export default /*#__PURE__*/_defineComponent({
  __name: 'Price',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

// @ts-ignore
const locale = getConfigValue('locale');

const numberFormatOptions: { currencyDisplay: string; style: string; currency: string } = {
  currencyDisplay: 'code',
  style: 'currency',
  currency: 'EUR',
};




return (_ctx: any,_cache: any) => {
  return " € " + _toDisplayString(new Intl.NumberFormat(_unref(locale), numberFormatOptions).format(_ctx.value).replace("EUR", "").trim())
}
}

})